// src/setupProcess.js
if (!window.process) {
  window.process = { env: { NODE_ENV: "development" } };
}
